//* ---------------------------------------
//  Global Scoped Vendors

import 'focus-visible'
import 'formdata-polyfill'
import 'objectFitPolyfill'
import 'whatwg-fetch'

//* ---------------------------------------
//  Top Level Imports

import { Components } from './components/index'
import Component from './lib/component'
import Scroller from './lib/scroller'
import lottie from 'lottie-web' // eslint-disable-line no-unused-vars

//* ---------------------------------------
//  Create RootComponent

export const RootComponent = new Component({
    el: document.body,
    Scroller: new Scroller()
})

//* ---------------------------------------
//  Detect Features like Modernizr

RootComponent
    .addFeatureTest({
        csspointerevents: () => RootComponent.detectCSSProp('pointer-events'),
        csstouchaction: () => RootComponent.detectCSSProp('touch-action')
    })
    .addFeaturesToClassName()

//* ---------------------------------------
//  RootComponent on Scroll Toggling

RootComponent
    .on('scroll:disable', () => document.documentElement
        .classList.add('overflow-hidden'))

RootComponent
    .on('scroll:enable', () => document.documentElement
        .classList.remove('overflow-hidden'))

//* ---------------------------------------
//  RootComponent on Resize

RootComponent
    .on('resize', () => window.objectFitPolyfill())

//* ---------------------------------------
//  RootComponent on Render

RootComponent
    .on('render', (e) => Promise
        .resolve(Object.keys(Components)
            .filter(key => 'selector' in Components[key]
                && typeof Components[key] === 'function'
                && RootComponent.el
                && RootComponent.el.querySelector(Components[key].selector()))
            .forEach(key => Array.from(document
                .querySelectorAll(`${
                    Components[key].selector()}:not([data-rendered])`))
                .filter(el => !el.getAttribute('data-rendered'))
                .forEach(el => Promise
                    .resolve(new Components[key]({
                        el,
                        props: el.dataset
                    })))))
        .then(() => window.objectFitPolyfill()))
    .emit('render')
